import { createUseStyles } from 'react-jss';


import colors from "../../../utils/colors";

var styles = {
  userAccountWrapper: function userAccountWrapper(_ref) {var customMainColor = _ref.customMainColor;return {
      display: 'flex',
      alignItems: 'center',
      height: '6.4rem',
      borderLeft: "1px solid ".concat(customMainColor || colors.neutral[900]),
      paddingLeft: '1.6rem',
      paddingRight: '2.4rem',
      cursor: 'pointer'
    };},
  userPreview: function userPreview(_ref2) {var customMainColor = _ref2.customMainColor;return {
      borderRadius: '50%',
      backgroundColor: customMainColor || colors.neutral[900],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '4rem',
      minHeight: '4rem'
    };},
  userPreviewText: {
    font: {
      size: '1.8rem',
      lineHeight: '2.4rem',
      weight: 700
    },
    color: colors.neutral.white
  },
  userName: { margin: 0, font: { size: '1.4rem', lineHeight: '2.24rem', weight: 700 } },
  userPosition: {
    margin: 0,
    font: { size: '1.4rem', lineHeight: '2rem', weight: 400 },
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '20rem'
  },
  userInfo: {
    paddingLeft: '1.2rem'
  },
  openIcon: {
    marginLeft: 'auto'
  },
  sandboxIconWrapper: {
    marginRight: '1rem'
  },
  affiliationWrapper: {
    display: 'flex',
    alignItems: 'center'
  }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map